import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { MaintenanceFormData, MaintenanceWorkspaceTab } from '../types';

interface MaintenanceWorkspaceState {
	pendingFormData: MaintenanceFormData | null;
	activeTab: MaintenanceWorkspaceTab;
	reportActiveMonth: string;

	setPendingFormData: (data: MaintenanceFormData) => void;
	setActiveTab: (item: MaintenanceWorkspaceTab) => void;
	setReportActiveMonth: (month: string) => void;
	reset: () => void;
}

const initialState = {
	pendingFormData: null,
	activeTab: 'general' as MaintenanceWorkspaceTab,
	reportActiveMonth: '',
};

export const useMaintenanceStore = create<MaintenanceWorkspaceState>()(
	devtools(
		(set) => ({
			...initialState,

			setPendingFormData: (data) => set({ pendingFormData: data }),

			setActiveTab: (item) => set({ activeTab: item }),

			setReportActiveMonth: (month) => set({ reportActiveMonth: month }),

			reset: () => set(initialState),
		}),
		{ name: 'MaintenanceWorkspaceStore' }
	)
);
